import React, {useEffect, useState, useCallback} from 'react'
import PropTypes from 'prop-types'
import FAQ from '../faq/FAQ'
import MethodTitle from '../misc/Method-title/MethodTitle'
import {getI18nTextWithContext, getI18nTextWithParentKey} from "wipi-common/src/lib/i18n";
import ShortCaseInfo from '../misc/ShortCaseInfo'
import BackToMethodSelectionButton from '../misc/BackToMethodSelectionButton'
import {LOG_EVENTS} from 'wipi-common/src/lib/logging/events'
import './StartEudiwId.scss'
import LOG from "wipi-common/src/lib/logging/logger"
import {useI18nContext} from "../i18n/I18nContext"
import eudiwidIlluDark from '../../assets/illustrations/eudiwid-description-dark.svg'
import eudiwidIlluLight from '../../assets/illustrations/eudiwid-description-light.svg'
import eudiwidDark from '../../assets/illustrations/eudiwallet-dark.svg'
import eudiwidLight from '../../assets/illustrations/eudiwallet-light.svg'
import {createEudiwIdent, acceptEudiwTerms, createEudiwAttempt, createEudiwVpLink} from "../../lib/emmiApi";
import Text from "../i18n/Text";
import Spinner from "../misc/Spinner";
import {useNavigate} from 'react-router-dom';
import AppDownload from "../misc/AppDownload";

export default function StartEudiwId({caseInfo, isMobileDevice}) {
    const context = useI18nContext()
    const [status, setStatus] = useState('idle');
    const navigate = useNavigate();

    useEffect(() => {
        LOG.logInfo(LOG_EVENTS.PD_START_EUDIWID)
    }, [context])

    const handleClick = useCallback((event) => {
        event.stopPropagation();
        setStatus('loading');
        const caseId = caseInfo.caseId;
        createEudiwIdent(caseId)
            .then(() => acceptEudiwTerms(caseId))
            .then(() => createEudiwAttempt(caseId))
            .then((attemptResult) => {
                LOG.logInfo(LOG_EVENTS.EW_VPLINK_CREATE)
                const attemptId = attemptResult.attemptId;
                return createEudiwVpLink(caseId, attemptId);
            })
            .then((vpLinkResult) => {
                window.open(vpLinkResult.openID4VPUrl, '_blank');
                navigate('/eudiwid/processing?caseId=' + caseInfo.caseId);
            })
            .catch(() => setStatus('error'));
    }, [caseInfo.caseId, navigate]);

    return (
        <>
            <div className="headless">
                <div className="col-xl-6 col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 col-12">
                    <div className="row max-w-75 mx-auto">
                        <MethodTitle
                            heading={getI18nTextWithContext(context, 'startEudiwId.heading')}
                            subHeading={null}
                            info={getI18nTextWithContext(context, 'startEudiwId.info')}
                            testId="hfmvwi41a4p9"/>
                    </div>

                    <div className="row max-w-75 mx-auto">
                        <div className="col-xxl-4 offset-xxl-0 col-xl-6 offset-xl-0 col-lg-6 offset-lg-0 col-md-6 offset-md-3 col-sm-6 offset-sm-3 mb-sm-3 col-6 offset-2 mb-3 justify-content-center">
                            <img id="eudiwallet-light" className="light-img-eudiwallet" src={eudiwidLight} alt="" data-test-id="a3ea19d6-614b"/>
                            <img id="eudiwallet-dark" className="dark-img-eudiwallet" src={eudiwidDark} alt="" data-test-id="a3ea19d6-614b"/>
                        </div>
                        <div className="col-xxl-6 offset-xxl-0 col-xl-6 offset-xl-0 col-lg-6 offset-lg-0 col-md-12 offset-md-0 col-sm-12 col-12 d-flex flex-column justify-content-center">
                            <h2 className="h5">{getI18nTextWithContext(context, 'startEudiwId.howTo.heading')}</h2>
                            {!isMobileDevice && (
                                <p>{getI18nTextWithContext(context, 'startEudiwId.howTo.desktop.subHeading')}</p>
                            )}
                            {isMobileDevice && (
                                <p>{getI18nTextWithContext(context, 'startEudiwId.howTo.ident.subHeading')}</p>
                            )}
                        </div>

                    </div>

                    { isMobileDevice && (
                    <div className="row">
                        {/* QR Code description */}
                        {(eudiwidIlluLight && eudiwidIlluDark) && (
                            <div className="col-xxl-4 offset-xxl-0 col-xl-4 offset-xl-0 col-lg-4 offset-lg-0 col-md-6 offset-md-3 col-sm-6 offset-sm-3 mb-sm-3 col-6 offset-3 mb-3">
                                <img id="illustration-light" className="description-illu" src={eudiwidIlluLight} alt="" data-test-id="09ea9966-711b"/>
                                <img id="illustration-dark" className="description-illu" src={eudiwidIlluDark} alt="" data-test-id="09ea9966-711b"/>
                            </div>
                        )}
                        {status === 'loading' && (
                            <div className="col-xxl-6 offset-xxl-0 col-xl-6 offset-xl-0 col-lg-6 offset-lg-0 col-md-8 offset-md-0 col-sm-8 col-12 d-flex flex-column justify-content-center">
                                <Spinner />
                            </div>
                        )}
                        {status === 'idle' && (
                            <div className="col-xxl-6 offset-xxl-0 col-xl-6 offset-xl-0 col-lg-6 offset-lg-0 col-md-8 offset-md-2 col-sm-8 offset-sm-2 col-12 d-flex flex-column justify-content-center">
                                <button className="btn btn-primary btn-block" data-test-id="a2b810f4-918c" onClick={handleClick}>
                                    <Text k="startEudiwId.ident.button"/>
                                </button>
                            </div>
                        )}
                    </div>
                    )}

                    { !isMobileDevice && (

                        <AppDownload caseId={caseInfo.caseId} availability="" illustrationDark={eudiwidIlluDark} illustrationLight={eudiwidIlluLight}/>
                    )}

                    <div className="mt-5">
                        <BackToMethodSelectionButton caseInfo={caseInfo} isMobileDevice={isMobileDevice}/>
                    </div>
                </div>
                <ShortCaseInfo caseId={caseInfo.caseId} bcName={caseInfo.principalDisplayName}/>
            </div>
            <FAQ faq={getI18nTextWithParentKey(context, 'startEudiwId.faq')}/>
        </>
    );
}

StartEudiwId.propTypes = {
    caseInfo: PropTypes.shape({
        caseId: PropTypes.string.isRequired,
        principalDisplayName: PropTypes.string.isRequired,
        modules: PropTypes.shape({
            identMethodSelection: PropTypes.shape({
                methodChoice: PropTypes.arrayOf(
                    PropTypes.shape({
                        method: PropTypes.string.isRequired,
                        footer: PropTypes.string
                    })
                ).isRequired
            }).isRequired
        }).isRequired
    }).isRequired,
    isMobileDevice: PropTypes.bool.isRequired
};